import React, { useState } from 'react';
import { ArrowRightIcon, Loader2Icon, MapPinIcon, UserIcon, PhoneIcon, MailIcon } from 'lucide-react';
interface CashOfferFormProps {
  buttonText?: string;
  className?: string;
}
export function CashOfferForm({
  buttonText = 'Get My Cash Offer',
  className = ''
}: CashOfferFormProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  if (isSuccess) {
    return <div className={`text-center py-8 ${className}`} data-id="element-23">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-24">
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-25">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-26" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-[#1B2A4A] mb-2" data-id="element-27">
          Request Received!
        </h3>
        <p className="text-slate-600" data-id="element-28">
          We're reviewing your property details and will call you within 24
          hours.
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className={`space-y-4 ${className}`} data-id="element-29">
      <div data-id="element-30">
        <label htmlFor="address" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-31">
          Property Address
        </label>
        <div className="relative" data-id="element-32">
          <MapPinIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-33" />
          <input type="text" id="address" required className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#E8913A] focus:border-[#E8913A] outline-none transition-colors text-slate-900 placeholder:text-slate-400" placeholder="123 Main St, City, State" data-id="element-34" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-35">
        <div data-id="element-36">
          <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-37">
            Full Name
          </label>
          <div className="relative" data-id="element-38">
            <UserIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-39" />
            <input type="text" id="name" required className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#E8913A] focus:border-[#E8913A] outline-none transition-colors text-slate-900 placeholder:text-slate-400" placeholder="John Doe" data-id="element-40" />
          </div>
        </div>
        <div data-id="element-41">
          <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-42">
            Phone Number
          </label>
          <div className="relative" data-id="element-43">
            <PhoneIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-44" />
            <input type="tel" id="phone" required className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#E8913A] focus:border-[#E8913A] outline-none transition-colors text-slate-900 placeholder:text-slate-400" placeholder="(555) 123-4567" data-id="element-45" />
          </div>
        </div>
      </div>

      <div data-id="element-46">
        <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-47">
          Email Address
        </label>
        <div className="relative" data-id="element-48">
          <MailIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-49" />
          <input type="email" id="email" required className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#E8913A] focus:border-[#E8913A] outline-none transition-colors text-slate-900 placeholder:text-slate-400" placeholder="john@example.com" data-id="element-50" />
        </div>
      </div>

      <div className="pt-2" data-id="element-51">
        <button type="submit" disabled={isSubmitting} className="w-full bg-[#E8913A] hover:bg-[#D17E2E] text-white font-bold py-3.5 px-6 rounded-md transition-colors flex items-center justify-center group disabled:opacity-70" data-id="element-52">
          {isSubmitting ? <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-53" /> : <>
              {buttonText}
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-54" />
            </>}
        </button>
      </div>

      <p className="text-xs text-slate-500 pt-2 leading-relaxed" data-id="element-55">
        By submitting this form, you consent to receive calls and text messages
        from Bevo Coastal Investments at the phone number provided, including by
        autodialer. Consent is not a condition of purchase. Msg &amp; data rates
        may apply. Reply STOP to opt out.
      </p>
    </form>;
}